"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SVBTextarea;
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.parse-int.js");
require("core-js/modules/es.regexp.to-string.js");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
* Global components
* By Juan Rodrigo <jponceflores@svb.com> (www.svb.com)
* Summary
* This component renders a SVB textarea
*/

/**
* SVBTextarea
* @param {boolean} [isDisabled = false] - Boolean that determines if the textarea is disabled or not
* @param {string} [label] - Text to be displayed in the textarea label
* @param {boolean} [isError = false] - Boolean that determines if the textarea is an error or not
* @param {number} [maxCharacterCount] - Maximun number of characters allowed for the textarea
* @param {string} [helpText] - Help text to be displayed
* @param {number} [textareaWidth = 3] - Width of the textarea (in bootstrap numbers 1 to 12)
* @param {number} [rows = 4] - Number of rows of the textarea (height)
* @param {function} handleOnChange - Function to be excecuted on textarea input change
* @param {string} name - Name of the textarea
* @param {(string|number)} value - Value of the textarea
* @param {string} [placeholder] - Text to be displayed as the textarea placeholder
* @param {string} id - Id for the textarea
* @param {string} [extraClasses = ""] - Extra classes to be added to the text textarea wrapper
* @returns JSX element
*/
function SVBTextarea(props) {
  (0, _react.useLayoutEffect)(() => {
    const event = new CustomEvent("SVBApplyStylesBehavior", {
      detail: "textarea"
    });
    document.dispatchEvent(event);
  }, []);

  // Prop error handling
  let componentError = false;
  const typeCheck = function typeCheck(prop, types) {
    let extraValidations = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    if (!types.includes(typeof prop)) componentError = true;
    if (extraValidations && typeof prop !== "undefined") {
      for (let validation of extraValidations) {
        if (!validation(prop)) componentError = true;
      }
    }
    return prop;
  };
  const isBootstrapWidth = width => !(width > 12 || width < 1 || !Number.isInteger(width));
  const isDisabled = typeCheck(props.isDisabled, ["boolean", "undefined"]) || false;
  const label = typeCheck(props.label, ["string", "undefined"]);
  const isError = typeCheck(props.isError, ["boolean", "undefined"]) || false;
  const maxCharacterCount = typeCheck(props.maxCharacterCount, ["number", "undefined"]) && parseInt(props.maxCharacterCount);
  const helpText = typeCheck(props.helpText, ["string", "undefined"]);
  const hasTextBelow = [maxCharacterCount, helpText].some(element => element);
  const textareaWidth = typeCheck(props.textareaWidth, ["number", "undefined"], [isBootstrapWidth]) || 3;
  const rows = typeCheck(props.rows, ["number", "undefined"], [rows => Number.isInteger(rows) && rows > 0]) || 4;
  const handleOnChange = typeCheck(props.handleOnChange, ["function"]);
  const name = typeCheck(props.name, ["string"]);
  const value = typeCheck(props.value, ["string", "number"]);
  const placeholder = typeCheck(props.placeholder, ["string", "undefined"]);
  const id = typeCheck(props.id, ["string"]);
  const extraClasses = typeCheck(props.extraClasses, ["string", "undefined"]) || "";

  // Prop error check
  if (componentError) return /*#__PURE__*/_react.default.createElement("p", null, "Invalid prop sent, check console for prop type errors.");
  const getMarginBottom = indicator => indicator ? "" : "mb-3";
  const getTextareaErrorClass = indicator => indicator ? "textarea-error" : "";
  const getTextareaHelpClass = indicator => indicator ? "textarea-help" : "";
  const getTextareaLabelClass = indicator => indicator ? "" : "textarea-no-label";
  const getLabelErrorClass = indicator => indicator ? "label-error" : "";
  const getLabelDisabledClass = indicator => indicator ? "label-disabled" : "";
  const getHelpErrorClass = indicator => indicator ? "textarea-help-text-error" : "";
  return /*#__PURE__*/_react.default.createElement("div", {
    className: extraClasses
  }, /*#__PURE__*/_react.default.createElement("textarea", {
    className: "".concat(getTextareaLabelClass(label), " ").concat(getTextareaHelpClass(hasTextBelow), " ").concat(getTextareaErrorClass(isError), " ").concat(getMarginBottom(hasTextBelow), " col-").concat(textareaWidth),
    rows: rows,
    onChange: handleOnChange,
    name: name,
    id: id,
    placeholder: placeholder,
    value: value,
    disabled: isDisabled,
    maxLength: maxCharacterCount
  }), label && /*#__PURE__*/_react.default.createElement("label", {
    className: "textarea_label ".concat(getLabelDisabledClass(isDisabled), " ").concat(getLabelErrorClass(isError)),
    htmlFor: id
  }, label), helpText && /*#__PURE__*/_react.default.createElement("p", {
    className: "textarea-help-text textarea-help-text_info ".concat(getHelpErrorClass(isError))
  }, helpText), maxCharacterCount && /*#__PURE__*/_react.default.createElement("p", {
    className: "textarea-help-text textarea-help-text_character-count ".concat(getHelpErrorClass(isError))
  }, "".concat(value.length.toString().padStart(maxCharacterCount.toString().length, "0"), "/").concat(maxCharacterCount)));
}
;
SVBTextarea.propTypes = {
  isDisabled: _propTypes.default.bool,
  label: _propTypes.default.string,
  isError: _propTypes.default.bool,
  maxCharacterCount: _propTypes.default.number,
  helpText: _propTypes.default.string,
  textareaWidth: function textareaWidth(props, propName) {
    if (typeof props[propName] !== "undefined") {
      if (typeof props[propName] !== "number" || props[propName] < 1 || props[propName] > 12 || !Number.isInteger(props[propName])) {
        return new Error("Invalid ".concat(propName, " prop - ").concat(propName, " prop must be an integer between 1 and 12"));
      }
    }
  },
  rows: function rows(props, propName) {
    if (typeof props[propName] !== "undefined") {
      if (!Number.isInteger(props[propName]) || props[propName] < 1) {
        return new Error("Invalid ".concat(propName, " prop - ").concat(propName, " prop must be an integer equal or higuer than 1"));
      }
    }
  },
  handleOnChange: _propTypes.default.func.isRequired,
  name: _propTypes.default.string.isRequired,
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,
  placeholder: _propTypes.default.string,
  id: _propTypes.default.string.isRequired,
  extraClasses: _propTypes.default.string
};